<template>
	<div v-html="html"></div>
</template>

<script>

	export default {

		data() {
			return {
				html: ''
			}
		},

		mounted() {
			axios.get('/templates/footer')
			.then(response => {
				this.html = response.data
			});
		}

	}
</script>